import React from "react";
import { intrductoryData, menuData } from "../const/profileConstants";
import BaseSectionItem from "./BaseSectionItem";

function IntoductoryItem() {
  return (
    <BaseSectionItem header={menuData[0].value}>
      <div
        className="description"
        dangerouslySetInnerHTML={{ __html: intrductoryData.description }}
      ></div>
    </BaseSectionItem>
  );
}
export default IntoductoryItem;
